module.exports = __webpack_public_path__ + "static/media/RedWarning.16f60ccd.svg";